import React, { useCallback, useState } from 'react';
import ExpandMoreIcon from 'material-ui/svg-icons/navigation/expand-more';
import ExpandLessIcon from 'material-ui/svg-icons/navigation/expand-less';

const styles = {
    icon: {
        margin: '-3px 15px 0 0',
        verticalAlign: 'middle',
        color: '#b2b2b2',
    },
};

/**
 * @param {{
 *   title: string,
 *   children: React.ReactNode,
 *   disabled?: boolean,
 *   titleControl?: React.ReactNode,
 *   initiallyCollapsed?: boolean,
 * }} props
 */
export default function CollapsableSection({ title, children, disabled, titleControl, initiallyCollapsed }) {
    const [collapsed, setCollapsed] = useState(!!initiallyCollapsed);
    const toggleCollapsed = useCallback(() => {
        if (!disabled) {
            setCollapsed(v => !v)
        }
    }, [disabled]);
    return (
        <div className='paper-block margin-bottom'>
            <div className='row'>
                <div className='col-xs-6'>
                    <span
                        className='name-block static huge-name'
                        onClick={toggleCollapsed}
                        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                    >
                        {!disabled && !collapsed && <ExpandLessIcon style={styles.icon} />}
                        {(disabled || collapsed) && <ExpandMoreIcon style={styles.icon} />}
                        {title}
                    </span>
                </div>
                <div className="col-xs-3 col-xs-offset-3">
                    {!disabled && !collapsed && titleControl}
                </div>
            </div>
            {!disabled && !collapsed && (
                <div className='row'>
                    <div className='col-xs-12'>
                        {children}
                    </div>
                </div>
            )}
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Size/Sidebar/Size/CollapsableSection.jsx